import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mrr',
  templateUrl: './mrr.component.html',
  styleUrls: ['./mrr.component.scss']
})
export class MrrComponent implements OnInit {
  @Input() valor: number = null;
  @Input() porcentagem: number;
  @Input() fonte: string;
  constructor() { }

  ngOnInit(): void {
  }

}
